import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import PaymentsFilter from './filterEntity';
import FilterModel from './filterModel';

import { Payments } from '@/models/payments';
import { TableApiInterface } from '@/types/page/table';
import { formatDateForInput } from '@/utils/date';
import { getIsDemo } from '@/utils/env';

export const MODULE_NAME = Payments.moduleName;

const filterModel = new FilterModel();
const filter = getModule(PaymentsFilter);

filter.setFilterName('paymentsFilter');
filter.setTemplateClassName('template-lg');
filter.setFilterModel(filterModel.filterModel);
filter.setFilterHandlers(filterModel.filterHandlers);

const PaymentLinkBody: Record<string, string> = {
    subscription: 'directories/subscriptions',
    consultation: 'consultations',
}

const PaymentLinkTextPrefix: Record<string, string> = {
    subscription: 'Подписка',
    consultation: '',
}

const sberLinkUrl = getIsDemo() ? 'https://yookassa.ru/my/payments' : 'https://yookassa.ru/my/payments';

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class PaymentsModule extends PageBaseModule {
    filter = filter;

    constructor(module: PaymentsModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle(Payments.listTitle);

        page.values.actionPagination = 'payments/updatePage';
        page.values.actionPageAmountItems = 'payments/updatePageAmountItems';
        page.values.pageAmountItems = 50;

        this.pageSettings = page.values;
        this.pageSettings.routeName = `${Payments.moduleName}_edit`;
        this.pageSettings.routeParam = `${Payments.moduleName}Id`;
    }

    @Action({ rawError: true })
    async init() {
        // has required filters
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(Payments.moduleName,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,

            );
            const table = await this.processList(result.table);
            await this.setList(table);
        } catch (clientError: any) {
            const error = clientError.response.data;

            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });
        }
    }

    @Action({ rawError: true })
    processList(table: TableApiInterface) {
        table.titles.map(title => {
            if (title.id === 'medicalServiceType') {
                title.id = 'serviceType';
            }

            return title;
        });

        table.rows = table.rows.map(row => {
            const result: Record<string, any> = {};

            for (const key in row) {
                const value = row[key];
                if (key === 'patient' && value) {
                    result[key] =
                        `<a href="${window.location.origin}/patients/${value.id}" target="_blank" class="cp-table__item-link">
                            ${value.title}
                        </a>`;
                    continue;
                }

                if (key === 'doctor' && value) {
                    result[key] =
                        `<a href="${window.location.origin}/doctors/${value.id}" target="_blank" class="cp-table__item-link">
                            ${value.title}
                        </a>`;
                    continue;
                }

                if (key === 'clinic' && value) {
                    result[key] =
                        `<a href="${window.location.origin}/clinics/${value.id}" target="_blank" class="cp-table__item-link">
                            ${value.title}
                        </a>`;
                    continue;
                }

                if (key === 'medicalServiceType') {
                    result.serviceType =
                        value
                        ? `<a href="${window.location.origin}/${PaymentLinkBody[row.targetType]}/${row.targetId}" target="_blank" class="cp-table__item-link">
                            ${[PaymentLinkTextPrefix[row.targetType], value.title].join(' ').trim()}
                        </a>`
                        : value;
                    continue;
                }

                if (key === 'paidAt' && value) {
                    result[key] = formatDateForInput(value);
                    continue;
                }

                if (key === 'link') {
                    result['link_yookassa'] = value ? `<a href="${sberLinkUrl}" target="_blank" class="cp-table__item-link">
                            ${value}
                        </a>` : '-';
                    continue;
                }

                result[key] = row[key];
            }

            return result;
        });

        return table;
    }
}

export default getModule(PaymentsModule);
